export default {
  'disputes.sectionTitle': 'Disputes',
  'disputes.title': 'Disputes',
  'disputes.menuTitle': 'Disputes',
  'disputes.tab.all': 'All',
  'disputes.tab.opened': 'Opened',
  'disputes.tab.closed': 'Closed',
  'disputes.error.title.fetchList': 'Order list',
  'disputes.error.message.fetchList': 'Failed to get order list.',
};
